import API from "../utils/api";

export const getPromotionDiscountApi = async (filters) => {
  const response = await API.get("discount", { params: filters });
  return { response };
};

export const deletePromotionDiscountApi = async (id) => {
  const response = await API.delete(`discount/${id}`);
  return { response };
};

export const addPromotionDiscountApi = async (data) => {
  const response = await API.post("discount", data);
  return { response };
};

export const updatePromotionDiscountApi = async (data, id) => {
    try {
      const response = await API.put(`discount/${id}`, data);
      return response; 
    } catch (error) {
      // axios puts the backend response in error.response.data
      return error.response?.data || { status: false, message: "Something went wrong" };
    }
};

export const editPromotionDiscountApi = async (id) => {
  const response = await API.get(`discount/${id}/edit`);
  return { response };
};

export const getPromotionSettingsApi = async () => {
  const response = await API.get(`discount/settings`);
  // const response = {
  //   countries: [
  //     {
  //       id: 8,
  //       name: "Afghanistan",
  //       dial_code: "+93",
  //       continent_id: 1,
  //       code: "AF",
  //     },
  //     {
  //       id: 9,
  //       name: "Aland Islands",
  //       dial_code: "+358",
  //       continent_id: 6,
  //       code: "AX",
  //     },
  //     {
  //       id: 10,
  //       name: "Albania",
  //       dial_code: "+355",
  //       continent_id: 6,
  //       code: "AL",
  //     },
  //     {
  //       id: 11,
  //       name: "Algeria",
  //       dial_code: "+213",
  //       continent_id: 2,
  //       code: "DZ",
  //     },
  //     {
  //       id: 12,
  //       name: "American Samoa",
  //       dial_code: "+1684",
  //       continent_id: 5,
  //       code: "AS",
  //     },
  //     {
  //       id: 13,
  //       name: "Andorra",
  //       dial_code: "+376",
  //       continent_id: 6,
  //       code: "AD",
  //     },
  //     {
  //       id: 14,
  //       name: "Angola",
  //       dial_code: "+244",
  //       continent_id: 6,
  //       code: "AO",
  //     },
  //     {
  //       id: 15,
  //       name: "Anguilla",
  //       dial_code: "+1264",
  //       continent_id: 4,
  //       code: "AI",
  //     },
  //     {
  //       id: 16,
  //       name: "Antigua and Barbuda",
  //       dial_code: "+1268",
  //       continent_id: 4,
  //       code: "AG",
  //     },
  //     {
  //       id: 17,
  //       name: "Argentina",
  //       dial_code: "+54",
  //       continent_id: 3,
  //       code: "AR",
  //     },
  //     {
  //       id: 18,
  //       name: "Armenia",
  //       dial_code: "+374",
  //       continent_id: 1,
  //       code: "AM",
  //     },
  //     {
  //       id: 19,
  //       name: "Aruba",
  //       dial_code: "+297",
  //       continent_id: 4,
  //       code: "AW",
  //     },
  //     {
  //       id: 20,
  //       name: "Australia",
  //       dial_code: "+61",
  //       continent_id: 5,
  //       code: "AU",
  //     },
  //     {
  //       id: 21,
  //       name: "Austria",
  //       dial_code: "+43",
  //       continent_id: 6,
  //       code: "AT",
  //     },
  //     {
  //       id: 22,
  //       name: "Azerbaijan",
  //       dial_code: "+994",
  //       continent_id: 1,
  //       code: "AZ",
  //     },
  //     {
  //       id: 23,
  //       name: "Bahamas",
  //       dial_code: "+1242",
  //       continent_id: 4,
  //       code: "BS",
  //     },
  //     {
  //       id: 24,
  //       name: "Bahrain",
  //       dial_code: "+973",
  //       continent_id: 1,
  //       code: "BH",
  //     },
  //     {
  //       id: 25,
  //       name: "Bangladesh",
  //       dial_code: "+880",
  //       continent_id: 1,
  //       code: "BD",
  //     },
  //     {
  //       id: 26,
  //       name: "Barbados",
  //       dial_code: "+1246",
  //       continent_id: 4,
  //       code: "BB",
  //     },
  //     {
  //       id: 27,
  //       name: "Belarus",
  //       dial_code: "+375",
  //       continent_id: 6,
  //       code: "BY",
  //     },
  //     {
  //       id: 28,
  //       name: "Belgium",
  //       dial_code: "+32",
  //       continent_id: 6,
  //       code: "BE",
  //     },
  //     {
  //       id: 29,
  //       name: "Belize",
  //       dial_code: "+501",
  //       continent_id: 4,
  //       code: "BZ",
  //     },
  //     {
  //       id: 30,
  //       name: "Benin",
  //       dial_code: "+229",
  //       continent_id: 2,
  //       code: "BJ",
  //     },
  //     {
  //       id: 31,
  //       name: "Bermuda",
  //       dial_code: "+1441",
  //       continent_id: 4,
  //       code: "BM",
  //     },
  //     {
  //       id: 32,
  //       name: "Bhutan",
  //       dial_code: "+975",
  //       continent_id: 1,
  //       code: "BT",
  //     },
  //     {
  //       id: 33,
  //       name: "Bolivia",
  //       dial_code: "+591",
  //       continent_id: 3,
  //       code: "BO",
  //     },
  //     {
  //       id: 34,
  //       name: "Bonaire, Sint Eustatius and Saba",
  //       dial_code: "",
  //       continent_id: 4,
  //       code: "BQ",
  //     },
  //     {
  //       id: 35,
  //       name: "Bosnia and Herzegovina",
  //       dial_code: "+387",
  //       continent_id: 6,
  //       code: "BA",
  //     },
  //     {
  //       id: 36,
  //       name: "Botswana",
  //       dial_code: "+267",
  //       continent_id: 2,
  //       code: "BW",
  //     },
  //     {
  //       id: 37,
  //       name: "Bouvet Island",
  //       dial_code: "",
  //       continent_id: 7,
  //       code: "BV",
  //     },
  //     {
  //       id: 38,
  //       name: "Brazil",
  //       dial_code: "+55",
  //       continent_id: 3,
  //       code: "BR",
  //     },
  //     {
  //       id: 39,
  //       name: "British Indian Ocean Territory",
  //       dial_code: "+246",
  //       continent_id: 3,
  //       code: "IO",
  //     },
  //     {
  //       id: 40,
  //       name: "Brunei Darussalam",
  //       dial_code: "+673",
  //       continent_id: 1,
  //       code: "BN",
  //     },
  //     {
  //       id: 41,
  //       name: "Bulgaria",
  //       dial_code: "+359",
  //       continent_id: 6,
  //       code: "BG",
  //     },
  //     {
  //       id: 42,
  //       name: "Burkina Faso",
  //       dial_code: "+226",
  //       continent_id: 1,
  //       code: "BF",
  //     },
  //     {
  //       id: 43,
  //       name: "Burundi",
  //       dial_code: "+257",
  //       continent_id: 2,
  //       code: "BI",
  //     },
  //     {
  //       id: 44,
  //       name: "Cambodia",
  //       dial_code: "+855",
  //       continent_id: 1,
  //       code: "KH",
  //     },
  //     {
  //       id: 45,
  //       name: "Cameroon",
  //       dial_code: "+237",
  //       continent_id: 2,
  //       code: "CM",
  //     },
  //     {
  //       id: 46,
  //       name: "Canada",
  //       dial_code: "+1",
  //       continent_id: 4,
  //       code: "CA",
  //     },
  //     {
  //       id: 47,
  //       name: "Cape Verde",
  //       dial_code: "+238",
  //       continent_id: 2,
  //       code: "CV",
  //     },
  //     {
  //       id: 48,
  //       name: "Cayman Islands",
  //       dial_code: "+ 345",
  //       continent_id: 4,
  //       code: "KY",
  //     },
  //     {
  //       id: 49,
  //       name: "Central African Republic",
  //       dial_code: "+236",
  //       continent_id: 2,
  //       code: "CF",
  //     },
  //     {
  //       id: 50,
  //       name: "Chad",
  //       dial_code: "+235",
  //       continent_id: 2,
  //       code: "TD",
  //     },
  //     {
  //       id: 51,
  //       name: "Chile",
  //       dial_code: "+56",
  //       continent_id: 3,
  //       code: "CL",
  //     },
  //     {
  //       id: 52,
  //       name: "China",
  //       dial_code: "+86",
  //       continent_id: 1,
  //       code: "CN",
  //     },
  //     {
  //       id: 53,
  //       name: "Christmas Island",
  //       dial_code: "+61",
  //       continent_id: 1,
  //       code: "CX",
  //     },
  //     {
  //       id: 54,
  //       name: "Cocos (Keeling) Islands",
  //       dial_code: "+61",
  //       continent_id: 1,
  //       code: "CC",
  //     },
  //     {
  //       id: 55,
  //       name: "Colombia",
  //       dial_code: "+57",
  //       continent_id: 3,
  //       code: "CO",
  //     },
  //     {
  //       id: 56,
  //       name: "Comoros",
  //       dial_code: "+269",
  //       continent_id: 2,
  //       code: "KM",
  //     },
  //     {
  //       id: 57,
  //       name: "Congo",
  //       dial_code: "+242",
  //       continent_id: 2,
  //       code: "CG",
  //     },
  //     {
  //       id: 58,
  //       name: "Congo, Democratic Republic of the Congo",
  //       dial_code: "+243",
  //       continent_id: 2,
  //       code: "CD",
  //     },
  //     {
  //       id: 59,
  //       name: "Cook Islands",
  //       dial_code: "+682",
  //       continent_id: 5,
  //       code: "CK",
  //     },
  //     {
  //       id: 60,
  //       name: "Costa Rica",
  //       dial_code: "+506",
  //       continent_id: 4,
  //       code: "CR",
  //     },
  //     {
  //       id: 61,
  //       name: "Cote D'Ivoire",
  //       dial_code: "+225",
  //       continent_id: 2,
  //       code: "CI",
  //     },
  //     {
  //       id: 62,
  //       name: "Croatia",
  //       dial_code: "+385",
  //       continent_id: 6,
  //       code: "HR",
  //     },
  //     {
  //       id: 63,
  //       name: "Cuba",
  //       dial_code: "+53",
  //       continent_id: 4,
  //       code: "CU",
  //     },
  //     {
  //       id: 64,
  //       name: "Curacao",
  //       dial_code: "",
  //       continent_id: 4,
  //       code: "CW",
  //     },
  //     {
  //       id: 65,
  //       name: "Cyprus",
  //       dial_code: "+357",
  //       continent_id: 1,
  //       code: "CY",
  //     },
  //     {
  //       id: 66,
  //       name: "Czech Republic",
  //       dial_code: "+420",
  //       continent_id: 6,
  //       code: "CZ",
  //     },
  //     {
  //       id: 67,
  //       name: "Denmark",
  //       dial_code: "+45",
  //       continent_id: 6,
  //       code: "DK",
  //     },
  //     {
  //       id: 68,
  //       name: "Djibouti",
  //       dial_code: "+253",
  //       continent_id: 2,
  //       code: "DJ",
  //     },
  //     {
  //       id: 69,
  //       name: "Dominica",
  //       dial_code: "+1767",
  //       continent_id: 4,
  //       code: "DM",
  //     },
  //     {
  //       id: 70,
  //       name: "Dominican Republic",
  //       dial_code: "+1849",
  //       continent_id: 4,
  //       code: "DO",
  //     },
  //     {
  //       id: 71,
  //       name: "Ecuador",
  //       dial_code: "+593",
  //       continent_id: 3,
  //       code: "EC",
  //     },
  //     {
  //       id: 72,
  //       name: "Egypt",
  //       dial_code: "+20",
  //       continent_id: 2,
  //       code: "EG",
  //     },
  //     {
  //       id: 73,
  //       name: "El Salvador",
  //       dial_code: "+503",
  //       continent_id: 4,
  //       code: "SV",
  //     },
  //     {
  //       id: 74,
  //       name: "Equatorial Guinea",
  //       dial_code: "+240",
  //       continent_id: 2,
  //       code: "GQ",
  //     },
  //     {
  //       id: 75,
  //       name: "Eritrea",
  //       dial_code: "+291",
  //       continent_id: 2,
  //       code: "ER",
  //     },
  //     {
  //       id: 76,
  //       name: "Estonia",
  //       dial_code: "+372",
  //       continent_id: 6,
  //       code: "EE",
  //     },
  //     {
  //       id: 77,
  //       name: "Ethiopia",
  //       dial_code: "+251",
  //       continent_id: 2,
  //       code: "ET",
  //     },
  //     {
  //       id: 78,
  //       name: "Falkland Islands (Malvinas)",
  //       dial_code: "+500",
  //       continent_id: 3,
  //       code: "FK",
  //     },
  //     {
  //       id: 79,
  //       name: "Faroe Islands",
  //       dial_code: "+298",
  //       continent_id: 6,
  //       code: "FO",
  //     },
  //     {
  //       id: 80,
  //       name: "Fiji",
  //       dial_code: "+679",
  //       continent_id: 5,
  //       code: "FJ",
  //     },
  //     {
  //       id: 81,
  //       name: "Finland",
  //       dial_code: "+358",
  //       continent_id: 6,
  //       code: "FI",
  //     },
  //     {
  //       id: 82,
  //       name: "France",
  //       dial_code: "+33",
  //       continent_id: 6,
  //       code: "FR",
  //     },
  //     {
  //       id: 83,
  //       name: "French Guiana",
  //       dial_code: "",
  //       continent_id: 3,
  //       code: "GF",
  //     },
  //     {
  //       id: 84,
  //       name: "French Polynesia",
  //       dial_code: "+594",
  //       continent_id: 5,
  //       code: "PF",
  //     },
  //     {
  //       id: 85,
  //       name: "Gabon",
  //       dial_code: "+241",
  //       continent_id: 2,
  //       code: "GA",
  //     },
  //     {
  //       id: 86,
  //       name: "Gambia",
  //       dial_code: "+220",
  //       continent_id: 2,
  //       code: "GM",
  //     },
  //     {
  //       id: 87,
  //       name: "Georgia",
  //       dial_code: "+995",
  //       continent_id: 1,
  //       code: "GE",
  //     },
  //     {
  //       id: 88,
  //       name: "Germany",
  //       dial_code: "+49",
  //       continent_id: 6,
  //       code: "DE",
  //     },
  //     {
  //       id: 89,
  //       name: "Ghana",
  //       dial_code: "+233",
  //       continent_id: 2,
  //       code: "GH",
  //     },
  //     {
  //       id: 90,
  //       name: "Gibraltar",
  //       dial_code: "+350",
  //       continent_id: 6,
  //       code: "GI",
  //     },
  //     {
  //       id: 91,
  //       name: "Greece",
  //       dial_code: "+30",
  //       continent_id: 6,
  //       code: "GR",
  //     },
  //     {
  //       id: 92,
  //       name: "Greenland",
  //       dial_code: "+299",
  //       continent_id: 4,
  //       code: "GL",
  //     },
  //     {
  //       id: 93,
  //       name: "Grenada",
  //       dial_code: "+1473",
  //       continent_id: 4,
  //       code: "GD",
  //     },
  //     {
  //       id: 94,
  //       name: "Guadeloupe",
  //       dial_code: "+590",
  //       continent_id: 4,
  //       code: "GP",
  //     },
  //     {
  //       id: 95,
  //       name: "Guam",
  //       dial_code: "+1671",
  //       continent_id: 5,
  //       code: "GU",
  //     },
  //     {
  //       id: 96,
  //       name: "Guatemala",
  //       dial_code: "+502",
  //       continent_id: 4,
  //       code: "GT",
  //     },
  //     {
  //       id: 97,
  //       name: "Guernsey",
  //       dial_code: "+44",
  //       continent_id: 6,
  //       code: "GG",
  //     },
  //     {
  //       id: 98,
  //       name: "Guinea",
  //       dial_code: "+224",
  //       continent_id: 2,
  //       code: "GN",
  //     },
  //     {
  //       id: 99,
  //       name: "Guinea-Bissau",
  //       dial_code: "+245",
  //       continent_id: 2,
  //       code: "GW",
  //     },
  //     {
  //       id: 100,
  //       name: "Guyana",
  //       dial_code: "+595",
  //       continent_id: 3,
  //       code: "GY",
  //     },
  //     {
  //       id: 101,
  //       name: "Haiti",
  //       dial_code: "+509",
  //       continent_id: 4,
  //       code: "HT",
  //     },
  //     {
  //       id: 102,
  //       name: "Holy See (Vatican City State)",
  //       dial_code: "+379",
  //       continent_id: 6,
  //       code: "VA",
  //     },
  //     {
  //       id: 103,
  //       name: "Honduras",
  //       dial_code: "+504",
  //       continent_id: 4,
  //       code: "HN",
  //     },
  //     {
  //       id: 104,
  //       name: "Hong Kong",
  //       dial_code: "+852",
  //       continent_id: 1,
  //       code: "HK",
  //     },
  //     {
  //       id: 105,
  //       name: "Hungary",
  //       dial_code: "+36",
  //       continent_id: 6,
  //       code: "HU",
  //     },
  //     {
  //       id: 106,
  //       name: "Iceland",
  //       dial_code: "+354",
  //       continent_id: 6,
  //       code: "IS",
  //     },
  //     {
  //       id: 107,
  //       name: "India",
  //       dial_code: "+91",
  //       continent_id: 1,
  //       code: "IN",
  //     },
  //     {
  //       id: 108,
  //       name: "Indonesia",
  //       dial_code: "+62",
  //       continent_id: 1,
  //       code: "ID",
  //     },
  //     {
  //       id: 109,
  //       name: "Iran, Islamic Republic of",
  //       dial_code: "+98",
  //       continent_id: 1,
  //       code: "IR",
  //     },
  //     {
  //       id: 110,
  //       name: "Iraq",
  //       dial_code: "+964",
  //       continent_id: 1,
  //       code: "IQ",
  //     },
  //     {
  //       id: 111,
  //       name: "Ireland",
  //       dial_code: "+353",
  //       continent_id: 6,
  //       code: "IE",
  //     },
  //     {
  //       id: 112,
  //       name: "Isle of Man",
  //       dial_code: "+44",
  //       continent_id: 6,
  //       code: "IM",
  //     },
  //     {
  //       id: 113,
  //       name: "Israel",
  //       dial_code: "+972",
  //       continent_id: 1,
  //       code: "IL",
  //     },
  //     {
  //       id: 114,
  //       name: "Italy",
  //       dial_code: "+39",
  //       continent_id: 6,
  //       code: "IT",
  //     },
  //     {
  //       id: 115,
  //       name: "Jamaica",
  //       dial_code: "+1876",
  //       continent_id: 4,
  //       code: "JM",
  //     },
  //     {
  //       id: 116,
  //       name: "Japan",
  //       dial_code: "+81",
  //       continent_id: 1,
  //       code: "JP",
  //     },
  //     {
  //       id: 117,
  //       name: "Jersey",
  //       dial_code: "+44",
  //       continent_id: 6,
  //       code: "JE",
  //     },
  //     {
  //       id: 118,
  //       name: "Jordan",
  //       dial_code: "+962",
  //       continent_id: 1,
  //       code: "JO",
  //     },
  //     {
  //       id: 119,
  //       name: "Kazakhstan",
  //       dial_code: "+77",
  //       continent_id: 1,
  //       code: "KZ",
  //     },
  //     {
  //       id: 120,
  //       name: "Kenya",
  //       dial_code: "+254",
  //       continent_id: 2,
  //       code: "KE",
  //     },
  //     {
  //       id: 121,
  //       name: "Kiribati",
  //       dial_code: "+686",
  //       continent_id: 5,
  //       code: "KI",
  //     },
  //     {
  //       id: 122,
  //       name: "Korea, Democratic People's Republic of",
  //       dial_code: "+850",
  //       continent_id: 1,
  //       code: "KP",
  //     },
  //     {
  //       id: 123,
  //       name: "Korea, Republic of",
  //       dial_code: "+82",
  //       continent_id: 1,
  //       code: "KR",
  //     },
  //     {
  //       id: 124,
  //       name: "Kosovo",
  //       dial_code: "",
  //       continent_id: 6,
  //       code: "XK",
  //     },
  //     {
  //       id: 125,
  //       name: "Kuwait",
  //       dial_code: "+965",
  //       continent_id: 1,
  //       code: "KW",
  //     },
  //     {
  //       id: 126,
  //       name: "Kyrgyzstan",
  //       dial_code: "+996",
  //       continent_id: 1,
  //       code: "KG",
  //     },
  //     {
  //       id: 127,
  //       name: "Lao People's Democratic Republic",
  //       dial_code: "+856",
  //       continent_id: 1,
  //       code: "LA",
  //     },
  //     {
  //       id: 128,
  //       name: "Latvia",
  //       dial_code: "+371",
  //       continent_id: 6,
  //       code: "LV",
  //     },
  //     {
  //       id: 129,
  //       name: "Lebanon",
  //       dial_code: "+961",
  //       continent_id: 1,
  //       code: "LB",
  //     },
  //     {
  //       id: 130,
  //       name: "Lesotho",
  //       dial_code: "+266",
  //       continent_id: 2,
  //       code: "LS",
  //     },
  //     {
  //       id: 131,
  //       name: "Liberia",
  //       dial_code: "+231",
  //       continent_id: 2,
  //       code: "LR",
  //     },
  //     {
  //       id: 132,
  //       name: "Libyan Arab Jamahiriya",
  //       dial_code: "+218",
  //       continent_id: 2,
  //       code: "LY",
  //     },
  //     {
  //       id: 133,
  //       name: "Liechtenstein",
  //       dial_code: "+423",
  //       continent_id: 6,
  //       code: "LI",
  //     },
  //     {
  //       id: 134,
  //       name: "Lithuania",
  //       dial_code: "+370",
  //       continent_id: 6,
  //       code: "LT",
  //     },
  //     {
  //       id: 135,
  //       name: "Luxembourg",
  //       dial_code: "+352",
  //       continent_id: 6,
  //       code: "LU",
  //     },
  //     {
  //       id: 136,
  //       name: "Macao",
  //       dial_code: "+853",
  //       continent_id: 1,
  //       code: "MO",
  //     },
  //     {
  //       id: 137,
  //       name: "Macedonia, the Former Yugoslav Republic of",
  //       dial_code: "+389",
  //       continent_id: 6,
  //       code: "MK",
  //     },
  //     {
  //       id: 138,
  //       name: "Madagascar",
  //       dial_code: "+261",
  //       continent_id: 2,
  //       code: "MG",
  //     },
  //     {
  //       id: 139,
  //       name: "Malawi",
  //       dial_code: "+265",
  //       continent_id: 2,
  //       code: "MW",
  //     },
  //     {
  //       id: 140,
  //       name: "Malaysia",
  //       dial_code: "+60",
  //       continent_id: 1,
  //       code: "MY",
  //     },
  //     {
  //       id: 141,
  //       name: "Maldives",
  //       dial_code: "+960",
  //       continent_id: 1,
  //       code: "MV",
  //     },
  //     {
  //       id: 142,
  //       name: "Mali",
  //       dial_code: "+223",
  //       continent_id: 2,
  //       code: "ML",
  //     },
  //     {
  //       id: 143,
  //       name: "Malta",
  //       dial_code: "+356",
  //       continent_id: 6,
  //       code: "MT",
  //     },
  //     {
  //       id: 144,
  //       name: "Marshall Islands",
  //       dial_code: "+692",
  //       continent_id: 5,
  //       code: "MH",
  //     },
  //     {
  //       id: 145,
  //       name: "Martinique",
  //       dial_code: "+596",
  //       continent_id: 4,
  //       code: "MQ",
  //     },
  //     {
  //       id: 146,
  //       name: "Mauritania",
  //       dial_code: "+222",
  //       continent_id: 2,
  //       code: "MR",
  //     },
  //     {
  //       id: 147,
  //       name: "Mauritius",
  //       dial_code: "+230",
  //       continent_id: 2,
  //       code: "MU",
  //     },
  //     {
  //       id: 148,
  //       name: "Mayotte",
  //       dial_code: "+262",
  //       continent_id: 2,
  //       code: "YT",
  //     },
  //     {
  //       id: 149,
  //       name: "Mexico",
  //       dial_code: "+52",
  //       continent_id: 4,
  //       code: "MX",
  //     },
  //     {
  //       id: 150,
  //       name: "Micronesia, Federated States of",
  //       dial_code: "+691",
  //       continent_id: 5,
  //       code: "FM",
  //     },
  //     {
  //       id: 151,
  //       name: "Moldova, Republic of",
  //       dial_code: "+373",
  //       continent_id: 6,
  //       code: "MD",
  //     },
  //     {
  //       id: 152,
  //       name: "Monaco",
  //       dial_code: "+377",
  //       continent_id: 6,
  //       code: "MC",
  //     },
  //     {
  //       id: 153,
  //       name: "Mongolia",
  //       dial_code: "+976",
  //       continent_id: 1,
  //       code: "MN",
  //     },
  //     {
  //       id: 154,
  //       name: "Montenegro",
  //       dial_code: "+382",
  //       continent_id: 6,
  //       code: "ME",
  //     },
  //     {
  //       id: 155,
  //       name: "Montserrat",
  //       dial_code: "+1664",
  //       continent_id: 4,
  //       code: "MS",
  //     },
  //     {
  //       id: 156,
  //       name: "Morocco",
  //       dial_code: "+212",
  //       continent_id: 2,
  //       code: "MA",
  //     },
  //     {
  //       id: 157,
  //       name: "Mozambique",
  //       dial_code: "+258",
  //       continent_id: 2,
  //       code: "MZ",
  //     },
  //     {
  //       id: 158,
  //       name: "Myanmar",
  //       dial_code: "+95",
  //       continent_id: 1,
  //       code: "MM",
  //     },
  //     {
  //       id: 159,
  //       name: "Namibia",
  //       dial_code: "+264",
  //       continent_id: 2,
  //       code: "NA",
  //     },
  //     {
  //       id: 160,
  //       name: "Nauru",
  //       dial_code: "+674",
  //       continent_id: 5,
  //       code: "NR",
  //     },
  //     {
  //       id: 161,
  //       name: "Nepal",
  //       dial_code: "+977",
  //       continent_id: 1,
  //       code: "NP",
  //     },
  //     {
  //       id: 162,
  //       name: "Netherlands",
  //       dial_code: "+31",
  //       continent_id: 6,
  //       code: "NL",
  //     },
  //     {
  //       id: 163,
  //       name: "Netherlands Antilles",
  //       dial_code: "+599",
  //       continent_id: 4,
  //       code: "AN",
  //     },
  //     {
  //       id: 164,
  //       name: "New Caledonia",
  //       dial_code: "+687",
  //       continent_id: 5,
  //       code: "NC",
  //     },
  //     {
  //       id: 165,
  //       name: "New Zealand",
  //       dial_code: "+64",
  //       continent_id: 5,
  //       code: "NZ",
  //     },
  //     {
  //       id: 166,
  //       name: "Nicaragua",
  //       dial_code: "+505",
  //       continent_id: 4,
  //       code: "NI",
  //     },
  //     {
  //       id: 167,
  //       name: "Niger",
  //       dial_code: "+227",
  //       continent_id: 2,
  //       code: "NE",
  //     },
  //     {
  //       id: 168,
  //       name: "Nigeria",
  //       dial_code: "+234",
  //       continent_id: 2,
  //       code: "NG",
  //     },
  //     {
  //       id: 169,
  //       name: "Niue",
  //       dial_code: "+683",
  //       continent_id: 5,
  //       code: "NU",
  //     },
  //     {
  //       id: 170,
  //       name: "Norfolk Island",
  //       dial_code: "+672",
  //       continent_id: 5,
  //       code: "NF",
  //     },
  //     {
  //       id: 171,
  //       name: "Northern Mariana Islands",
  //       dial_code: "+1670",
  //       continent_id: 5,
  //       code: "MP",
  //     },
  //     {
  //       id: 172,
  //       name: "Norway",
  //       dial_code: "+47",
  //       continent_id: 6,
  //       code: "NO",
  //     },
  //     {
  //       id: 173,
  //       name: "Oman",
  //       dial_code: "+968",
  //       continent_id: 1,
  //       code: "OM",
  //     },
  //     {
  //       id: 174,
  //       name: "Pakistan",
  //       dial_code: "+92",
  //       continent_id: 1,
  //       code: "PK",
  //     },
  //     {
  //       id: 175,
  //       name: "Palau",
  //       dial_code: "+680",
  //       continent_id: 5,
  //       code: "PW",
  //     },
  //     {
  //       id: 176,
  //       name: "Palestinian Territory, Occupied",
  //       dial_code: "+970",
  //       continent_id: 1,
  //       code: "PS",
  //     },
  //     {
  //       id: 177,
  //       name: "Panama",
  //       dial_code: "+507",
  //       continent_id: 4,
  //       code: "PA",
  //     },
  //     {
  //       id: 178,
  //       name: "Papua New Guinea",
  //       dial_code: "+675",
  //       continent_id: 5,
  //       code: "PG",
  //     },
  //     {
  //       id: 179,
  //       name: "Paraguay",
  //       dial_code: "+595",
  //       continent_id: 3,
  //       code: "PY",
  //     },
  //     {
  //       id: 180,
  //       name: "Peru",
  //       dial_code: "+51",
  //       continent_id: 3,
  //       code: "PE",
  //     },
  //     {
  //       id: 181,
  //       name: "Philippines",
  //       dial_code: "+63",
  //       continent_id: 1,
  //       code: "PH",
  //     },
  //     {
  //       id: 182,
  //       name: "Pitcairn",
  //       dial_code: "+872",
  //       continent_id: 5,
  //       code: "PN",
  //     },
  //     {
  //       id: 183,
  //       name: "Poland",
  //       dial_code: "+48",
  //       continent_id: 6,
  //       code: "PL",
  //     },
  //     {
  //       id: 184,
  //       name: "Portugal",
  //       dial_code: "+351",
  //       continent_id: 6,
  //       code: "PT",
  //     },
  //     {
  //       id: 185,
  //       name: "Puerto Rico",
  //       dial_code: "+1939",
  //       continent_id: 4,
  //       code: "PR",
  //     },
  //     {
  //       id: 186,
  //       name: "Qatar",
  //       dial_code: "+974",
  //       continent_id: 1,
  //       code: "QA",
  //     },
  //     {
  //       id: 187,
  //       name: "Reunion",
  //       dial_code: "",
  //       continent_id: 2,
  //       code: "RE",
  //     },
  //     {
  //       id: 188,
  //       name: "Romania",
  //       dial_code: "+40",
  //       continent_id: 6,
  //       code: "RO",
  //     },
  //     {
  //       id: 189,
  //       name: "Russian Federation",
  //       dial_code: "+7",
  //       continent_id: 1,
  //       code: "RU",
  //     },
  //     {
  //       id: 190,
  //       name: "Rwanda",
  //       dial_code: "+250",
  //       continent_id: 2,
  //       code: "RW",
  //     },
  //     {
  //       id: 191,
  //       name: "Saint Barthelemy",
  //       dial_code: "+590",
  //       continent_id: 4,
  //       code: "BL",
  //     },
  //     {
  //       id: 192,
  //       name: "Saint Helena",
  //       dial_code: "+290",
  //       continent_id: 2,
  //       code: "SH",
  //     },
  //     {
  //       id: 193,
  //       name: "Saint Kitts and Nevis",
  //       dial_code: "+1869",
  //       continent_id: 4,
  //       code: "KN",
  //     },
  //     {
  //       id: 194,
  //       name: "Saint Lucia",
  //       dial_code: "+1758",
  //       continent_id: 4,
  //       code: "LC",
  //     },
  //     {
  //       id: 195,
  //       name: "Saint Martin",
  //       dial_code: "+590",
  //       continent_id: 4,
  //       code: "MF",
  //     },
  //     {
  //       id: 196,
  //       name: "Saint Pierre and Miquelon",
  //       dial_code: "+508",
  //       continent_id: 4,
  //       code: "PM",
  //     },
  //     {
  //       id: 197,
  //       name: "Saint Vincent and the Grenadines",
  //       dial_code: "+1784",
  //       continent_id: 4,
  //       code: "VC",
  //     },
  //     {
  //       id: 198,
  //       name: "Samoa",
  //       dial_code: "+685",
  //       continent_id: 5,
  //       code: "WS",
  //     },
  //     {
  //       id: 199,
  //       name: "San Marino",
  //       dial_code: "+378",
  //       continent_id: 6,
  //       code: "SM",
  //     },
  //     {
  //       id: 200,
  //       name: "Sao Tome and Principe",
  //       dial_code: "+239",
  //       continent_id: 2,
  //       code: "ST",
  //     },
  //     {
  //       id: 201,
  //       name: "Saudi Arabia",
  //       dial_code: "+966",
  //       continent_id: 1,
  //       code: "SA",
  //     },
  //     {
  //       id: 202,
  //       name: "Senegal",
  //       dial_code: "+221",
  //       continent_id: 2,
  //       code: "SN",
  //     },
  //     {
  //       id: 203,
  //       name: "Serbia",
  //       dial_code: "+381",
  //       continent_id: 6,
  //       code: "RS",
  //     },
  //     {
  //       id: 204,
  //       name: "Serbia and Montenegro",
  //       dial_code: "",
  //       continent_id: 6,
  //       code: "CS",
  //     },
  //     {
  //       id: 205,
  //       name: "Seychelles",
  //       dial_code: "+248",
  //       continent_id: 2,
  //       code: "SC",
  //     },
  //     {
  //       id: 206,
  //       name: "Sierra Leone",
  //       dial_code: "+232",
  //       continent_id: 2,
  //       code: "SL",
  //     },
  //     {
  //       id: 207,
  //       name: "Singapore",
  //       dial_code: "+65",
  //       continent_id: 1,
  //       code: "SG",
  //     },
  //     {
  //       id: 208,
  //       name: "Sint Maarten",
  //       dial_code: "",
  //       continent_id: 4,
  //       code: "SX",
  //     },
  //     {
  //       id: 209,
  //       name: "Slovakia",
  //       dial_code: "+421",
  //       continent_id: 6,
  //       code: "SK",
  //     },
  //     {
  //       id: 210,
  //       name: "Slovenia",
  //       dial_code: "+386",
  //       continent_id: 6,
  //       code: "SI",
  //     },
  //     {
  //       id: 211,
  //       name: "Solomon Islands",
  //       dial_code: "+677",
  //       continent_id: 5,
  //       code: "SB",
  //     },
  //     {
  //       id: 212,
  //       name: "Somalia",
  //       dial_code: "+252",
  //       continent_id: 2,
  //       code: "SO",
  //     },
  //     {
  //       id: 213,
  //       name: "South Africa",
  //       dial_code: "",
  //       continent_id: 2,
  //       code: "ZA",
  //     },
  //     {
  //       id: 214,
  //       name: "South Sudan",
  //       dial_code: "+27",
  //       continent_id: 2,
  //       code: "SS",
  //     },
  //     {
  //       id: 215,
  //       name: "Spain",
  //       dial_code: "+34",
  //       continent_id: 6,
  //       code: "ES",
  //     },
  //     {
  //       id: 216,
  //       name: "Sri Lanka",
  //       dial_code: "+94",
  //       continent_id: 1,
  //       code: "LK",
  //     },
  //     {
  //       id: 217,
  //       name: "Sudan",
  //       dial_code: "+249",
  //       continent_id: 2,
  //       code: "SD",
  //     },
  //     {
  //       id: 218,
  //       name: "Suriname",
  //       dial_code: "+597",
  //       continent_id: 3,
  //       code: "SR",
  //     },
  //     {
  //       id: 219,
  //       name: "Svalbard and Jan Mayen",
  //       dial_code: "+47",
  //       continent_id: 6,
  //       code: "SJ",
  //     },
  //     {
  //       id: 220,
  //       name: "Swaziland",
  //       dial_code: "+268",
  //       continent_id: 2,
  //       code: "SZ",
  //     },
  //     {
  //       id: 221,
  //       name: "Sweden",
  //       dial_code: "+46",
  //       continent_id: 6,
  //       code: "SE",
  //     },
  //     {
  //       id: 222,
  //       name: "Switzerland",
  //       dial_code: "+41",
  //       continent_id: 6,
  //       code: "CH",
  //     },
  //     {
  //       id: 223,
  //       name: "Syrian Arab Republic",
  //       dial_code: "+963",
  //       continent_id: 1,
  //       code: "SY",
  //     },
  //     {
  //       id: 224,
  //       name: "Taiwan, Province of China",
  //       dial_code: "+886",
  //       continent_id: 1,
  //       code: "TW",
  //     },
  //     {
  //       id: 225,
  //       name: "Tajikistan",
  //       dial_code: "+992",
  //       continent_id: 1,
  //       code: "TJ",
  //     },
  //     {
  //       id: 226,
  //       name: "Tanzania, United Republic of",
  //       dial_code: "+255",
  //       continent_id: 2,
  //       code: "TZ",
  //     },
  //     {
  //       id: 227,
  //       name: "Thailand",
  //       dial_code: "+66",
  //       continent_id: 1,
  //       code: "TH",
  //     },
  //     {
  //       id: 228,
  //       name: "Timor-Leste",
  //       dial_code: "+670",
  //       continent_id: 1,
  //       code: "TL",
  //     },
  //     {
  //       id: 229,
  //       name: "Togo",
  //       dial_code: "+228",
  //       continent_id: 2,
  //       code: "TG",
  //     },
  //     {
  //       id: 230,
  //       name: "Tokelau",
  //       dial_code: "+690",
  //       continent_id: 5,
  //       code: "TK",
  //     },
  //     {
  //       id: 231,
  //       name: "Tonga",
  //       dial_code: "+676",
  //       continent_id: 5,
  //       code: "TO",
  //     },
  //     {
  //       id: 232,
  //       name: "Trinidad and Tobago",
  //       dial_code: "+1868",
  //       continent_id: 4,
  //       code: "TT",
  //     },
  //     {
  //       id: 233,
  //       name: "Tunisia",
  //       dial_code: "+216",
  //       continent_id: 2,
  //       code: "TN",
  //     },
  //     {
  //       id: 234,
  //       name: "Turkey",
  //       dial_code: "+90",
  //       continent_id: 1,
  //       code: "TR",
  //     },
  //     {
  //       id: 235,
  //       name: "Turkmenistan",
  //       dial_code: "+993",
  //       continent_id: 1,
  //       code: "TM",
  //     },
  //     {
  //       id: 236,
  //       name: "Turks and Caicos Islands",
  //       dial_code: "+1649",
  //       continent_id: 4,
  //       code: "TC",
  //     },
  //     {
  //       id: 237,
  //       name: "Tuvalu",
  //       dial_code: "+688",
  //       continent_id: 5,
  //       code: "TV",
  //     },
  //     {
  //       id: 238,
  //       name: "Uganda",
  //       dial_code: "+256",
  //       continent_id: 2,
  //       code: "UG",
  //     },
  //     {
  //       id: 239,
  //       name: "Ukraine",
  //       dial_code: "+380",
  //       continent_id: 6,
  //       code: "UA",
  //     },
  //     {
  //       id: 240,
  //       name: "United Arab Emirates",
  //       dial_code: "+971",
  //       continent_id: 1,
  //       code: "AE",
  //     },
  //     {
  //       id: 241,
  //       name: "United Kingdom",
  //       dial_code: "+44",
  //       continent_id: 6,
  //       code: "GB",
  //     },
  //     {
  //       id: 242,
  //       name: "United States",
  //       dial_code: "+1",
  //       continent_id: 4,
  //       code: "US",
  //     },
  //     {
  //       id: 243,
  //       name: "United States Minor Outlying Islands",
  //       dial_code: "",
  //       continent_id: 4,
  //       code: "UM",
  //     },
  //     {
  //       id: 244,
  //       name: "Uruguay",
  //       dial_code: "+598",
  //       continent_id: 3,
  //       code: "UY",
  //     },
  //     {
  //       id: 245,
  //       name: "Uzbekistan",
  //       dial_code: "+998",
  //       continent_id: 1,
  //       code: "UZ",
  //     },
  //     {
  //       id: 246,
  //       name: "Vanuatu",
  //       dial_code: "+678",
  //       continent_id: 5,
  //       code: "VU",
  //     },
  //     {
  //       id: 247,
  //       name: "Venezuela",
  //       dial_code: "+58",
  //       continent_id: 3,
  //       code: "VE",
  //     },
  //     {
  //       id: 248,
  //       name: "Viet Nam",
  //       dial_code: "+84",
  //       continent_id: 1,
  //       code: "VN",
  //     },
  //     {
  //       id: 249,
  //       name: "Virgin Islands, British",
  //       dial_code: "+1284",
  //       continent_id: 4,
  //       code: "VG",
  //     },
  //     {
  //       id: 250,
  //       name: "Virgin Islands, U.s.",
  //       dial_code: "+1340",
  //       continent_id: 4,
  //       code: "VI",
  //     },
  //     {
  //       id: 251,
  //       name: "Wallis and Futuna",
  //       dial_code: "+681",
  //       continent_id: 5,
  //       code: "WF",
  //     },
  //     {
  //       id: 252,
  //       name: "Western Sahara",
  //       dial_code: "",
  //       continent_id: 2,
  //       code: "EH",
  //     },
  //     {
  //       id: 253,
  //       name: "Yemen",
  //       dial_code: "+967",
  //       continent_id: 1,
  //       code: "YE",
  //     },
  //     {
  //       id: 254,
  //       name: "Zambia",
  //       dial_code: "+260",
  //       continent_id: 2,
  //       code: "ZM",
  //     },
  //     {
  //       id: 255,
  //       name: "Zimbabwe",
  //       dial_code: "+263",
  //       continent_id: 2,
  //       code: "ZW",
  //     },
  //   ],
  //   shippings: [
  //     {
  //       id: 1,
  //       name: "Express",
  //       type: 1,
  //       type_value: "1",
  //       position: 1,
  //       is_active: 1,
  //       created_at: null,
  //       updated_at: null,
  //       type_name: "Ship on a Specific date",
  //     },
  //     {
  //       id: 2,
  //       name: "shipping",
  //       type: 3,
  //       type_value: "1",
  //       position: 99999,
  //       is_active: 1,
  //       created_at: "2024-06-30T07:30:23.000000Z",
  //       updated_at: "2024-06-30T07:30:23.000000Z",
  //       type_name: "Ship after no of Days",
  //     },
  //     {
  //       id: 3,
  //       name: "Next Day Shipping",
  //       type: 3,
  //       type_value: "1",
  //       position: 99999,
  //       is_active: 1,
  //       created_at: "2024-07-01T03:54:42.000000Z",
  //       updated_at: "2024-07-01T03:54:42.000000Z",
  //       type_name: "Ship after no of Days",
  //     },
  //     {
  //       id: 4,
  //       name: "Standard",
  //       type: 3,
  //       type_value: "1",
  //       position: 99999,
  //       is_active: 1,
  //       created_at: "2024-07-01T15:43:14.000000Z",
  //       updated_at: "2024-07-01T15:43:14.000000Z",
  //       type_name: "Ship after no of Days",
  //     },
  //     {
  //       id: 5,
  //       name: "c",
  //       type: 3,
  //       type_value: "1",
  //       position: 99999,
  //       is_active: 1,
  //       created_at: "2024-07-04T07:44:10.000000Z",
  //       updated_at: "2024-07-04T07:44:10.000000Z",
  //       type_name: "Ship after no of Days",
  //     },
  //     {
  //       id: 6,
  //       name: "Ex",
  //       type: 3,
  //       type_value: "1",
  //       position: 99999,
  //       is_active: 1,
  //       created_at: "2024-07-05T06:42:37.000000Z",
  //       updated_at: "2024-07-05T06:42:37.000000Z",
  //       type_name: "Ship after no of Days",
  //     },
  //     {
  //       id: 7,
  //       name: "Custom",
  //       type: 3,
  //       type_value: "1",
  //       position: 99999,
  //       is_active: 1,
  //       created_at: "2024-07-05T06:45:44.000000Z",
  //       updated_at: "2024-07-05T06:45:44.000000Z",
  //       type_name: "Ship after no of Days",
  //     },
  //     {
  //       id: 8,
  //       name: "Free Shipping",
  //       type: 3,
  //       type_value: "1",
  //       position: 99999,
  //       is_active: 1,
  //       created_at: "2025-02-18T12:48:41.000000Z",
  //       updated_at: "2025-02-18T12:48:41.000000Z",
  //       type_name: "Ship after no of Days",
  //     },
  //     {
  //       id: 9,
  //       name: "Free",
  //       type: 3,
  //       type_value: "1",
  //       position: 99999,
  //       is_active: 1,
  //       created_at: "2025-02-26T12:44:33.000000Z",
  //       updated_at: "2025-02-26T12:44:33.000000Z",
  //       type_name: "Ship after no of Days",
  //     },
  //   ],
  //   customers: [
  //     {
  //       id: 3,
  //       name: "John kugan (joshci@example.com)",
  //     },
  //     {
  //       id: 4,
  //       name: "kugan (hcridfsd@cexample.com)",
  //     },
  //     {
  //       id: 5,
  //       name: "sdgdfgfghf (idfsd@cexample.com)",
  //     },
  //     {
  //       id: 6,
  //       name: "sdgdfgfghf (idfd@cexample.com)",
  //     },
  //     {
  //       id: 7,
  //       name: "sdgdfgfghf (idfdf@cexample.com)",
  //     },
  //     {
  //       id: 8,
  //       name: "sdgdfgfghf (idfdff@cexample.com)",
  //     },
  //     {
  //       id: 9,
  //       name: "sdgdfgfghf (idfdfft@cexample.com)",
  //     },
  //     {
  //       id: 10,
  //       name: "email (idfdffft@cexample.com)",
  //     },
  //     {
  //       id: 11,
  //       name: "email email (idfdkft@cexample.com)",
  //     },
  //     {
  //       id: 12,
  //       name: "email (idfdkft@1cexample.com)",
  //     },
  //     {
  //       id: 13,
  //       name: "email (idfdkfrt@1cexample.com)",
  //     },
  //     {
  //       id: 14,
  //       name: "phone (idfdkfr6tt2ky@1cexaggmple.com)",
  //     },
  //     {
  //       id: 17,
  //       name: "Subangan (subangan@akhitsolutions.com)",
  //     },
  //     {
  //       id: 18,
  //       name: "Siyara (shanuka+99@akhitsolutions.com)",
  //     },
  //     {
  //       id: 20,
  //       name: "Vino (shanuka@akhitsolutions.com)",
  //     },
  //     {
  //       id: 22,
  //       name: "kuganesan upd (jo442@example.com)",
  //     },
  //     {
  //       id: 23,
  //       name: "phone (idfdkfrf6ty@1cexaggmple.com)",
  //     },
  //     {
  //       id: 24,
  //       name: "John kugan (john.smi4h@example.com)",
  //     },
  //     {
  //       id: 26,
  //       name: "Shanuka (shanukacroos96@gmail.com)",
  //     },
  //     {
  //       id: 27,
  //       name: "methan (methan@akhitsolutions.com)",
  //     },
  //     {
  //       id: 28,
  //       name: "Kimberly (xysapina@mailinator.com)",
  //     },
  //     {
  //       id: 29,
  //       name: "phone (idfdkfrf6@1cexaggmple.com)",
  //     },
  //     {
  //       id: 32,
  //       name: "Shikhar (admin@admin.com)",
  //     },
  //     {
  //       id: 33,
  //       name: "Kirsten (josehyno@mailinator.com)",
  //     },
  //     {
  //       id: 34,
  //       name: "nisha (john.sryhi@example.com)",
  //     },
  //     {
  //       id: 35,
  //       name: "Valayapathi (shanuka+44@akhitsolutions.com)",
  //     },
  //     {
  //       id: 41,
  //       name: "Rohit (rohit@gmail.com)",
  //     },
  //     {
  //       id: 43,
  //       name: "Love (love@gmail.com)",
  //     },
  //     {
  //       id: 45,
  //       name: "Shan (shanuka+181@akhitsolutions.com)",
  //     },
  //     {
  //       id: 46,
  //       name: "changeg (idfdkfrf6@xaggmple.com)",
  //     },
  //     {
  //       id: 47,
  //       name: "NP (np@gmail.com)",
  //     },
  //     {
  //       id: 48,
  //       name: "Weee (subang@akhitsolutions.com)",
  //     },
  //     {
  //       id: 49,
  //       name: "Shan (shanu@gmail.com)",
  //     },
  //     {
  //       id: 50,
  //       name: "Test A1 (shanuka+666@akhitsolutions.com)",
  //     },
  //     {
  //       id: 51,
  //       name: "Test C (shanuka+7455@akhitsolutions.com)",
  //     },
  //     {
  //       id: 54,
  //       name: "Anna (supuni+a@akhitsolutions.com)",
  //     },
  //     {
  //       id: 55,
  //       name: "Saji (test@gmail.com)",
  //     },
  //     {
  //       id: 56,
  //       name: "John kugan (john.smieryhi@example.com)",
  //     },
  //     {
  //       id: 57,
  //       name: "Ricky (ponting@gmail.com)",
  //     },
  //     {
  //       id: 58,
  //       name: "Vijay (shanuka+78@akhitsolutions.com)",
  //     },
  //     {
  //       id: 59,
  //       name: "Annalise (supuni+ak@akhitsolutions.com)",
  //     },
  //     {
  //       id: 60,
  //       name: "John kugan (john.smryhi@example.com)",
  //     },
  //     {
  //       id: 61,
  //       name: "Justice (supuni+justice@akhitsolutions.com)",
  //     },
  //     {
  //       id: 62,
  //       name: "kuganesan (jo44op@example.com)",
  //     },
  //     {
  //       id: 63,
  //       name: "John (supuni+jr@akhitsolutions.com)",
  //     },
  //     {
  //       id: 64,
  //       name: "vna1 (vna@example.com)",
  //     },
  //     {
  //       id: 65,
  //       name: "vfn (vfn@example.com)",
  //     },
  //     {
  //       id: 66,
  //       name: "v2 (v2@example.com)",
  //     },
  //     {
  //       id: 67,
  //       name: "fx (fx@example.com)",
  //     },
  //     {
  //       id: 68,
  //       name: "Fuck (duck@gmail.com)",
  //     },
  //     {
  //       id: 69,
  //       name: "ww (yghgh@gmail.com)",
  //     },
  //     {
  //       id: 70,
  //       name: "ram (shanuka+556@akhitsolutions.com)",
  //     },
  //     {
  //       id: 71,
  //       name: "Walter (supuni+wb@akhitsolutions.com)",
  //     },
  //     {
  //       id: 72,
  //       name: "Rhea (nekefetaq@mailinator.com)",
  //     },
  //     {
  //       id: 73,
  //       name: "John (d@d.k)",
  //     },
  //     {
  //       id: 74,
  //       name: "Sherlock (supuni@akhitsolutions.com)",
  //     },
  //     {
  //       id: 75,
  //       name: "Stone (povycow@mailinator.com)",
  //     },
  //     {
  //       id: 76,
  //       name: "Genevieve (nerumywe@mailinator.com)",
  //     },
  //     {
  //       id: 77,
  //       name: "Genevieve (nerumssywe@mailinator.com)",
  //     },
  //     {
  //       id: 78,
  //       name: "Genevieve (nerum@mailinator.com)",
  //     },
  //     {
  //       id: 79,
  //       name: "Genevieve (nerum@massilinator.com)",
  //     },
  //     {
  //       id: 80,
  //       name: "Genevieve (nerum125@massilinator.com)",
  //     },
  //     {
  //       id: 81,
  //       name: "Genevieve (nerum3125@massilinator.com)",
  //     },
  //     {
  //       id: 82,
  //       name: "Genevieve (randin@hotmail.com)",
  //     },
  //     {
  //       id: 83,
  //       name: "Genevieve (nerumxs125@massilinator.com)",
  //     },
  //     {
  //       id: 84,
  //       name: "Genevieve (nerumys125@massilinator.com)",
  //     },
  //     {
  //       id: 85,
  //       name: "Genevieve (nerumhs125@massilinator.com)",
  //     },
  //     {
  //       id: 86,
  //       name: "Genevieve (nerumhy25@massilinator.com)",
  //     },
  //     {
  //       id: 87,
  //       name: "Genevieve (nerumh325@massilinator.com)",
  //     },
  //     {
  //       id: 88,
  //       name: "Genevieve (nerumh32t@massilinator.com)",
  //     },
  //     {
  //       id: 89,
  //       name: "Genevieve (randihyun@hotmail.com)",
  //     },
  //     {
  //       id: 90,
  //       name: "George (xamyb@mailinator.com)",
  //     },
  //     {
  //       id: 91,
  //       name: "Sheldon (supuni+s@akhitsolutions.com)",
  //     },
  //     {
  //       id: 92,
  //       name: "Jerome (supuni+b@akhitsolutions.com)",
  //     },
  //     {
  //       id: 93,
  //       name: "Mandy (supuni+m@akhitsolutions.com)",
  //     },
  //     {
  //       id: 94,
  //       name: "Maggy (foqirihezy@mailinator.com)",
  //     },
  //     {
  //       id: 95,
  //       name: "Harriet (manyz@mailinator.com)",
  //     },
  //     {
  //       id: 96,
  //       name: "Camille (vawu@mailinator.com)",
  //     },
  //     {
  //       id: 97,
  //       name: "Lane (jyxuseka@mailinator.com)",
  //     },
  //     {
  //       id: 98,
  //       name: "Arthur (fulu@mailinator.com)",
  //     },
  //     {
  //       id: 99,
  //       name: "richar (supuni+rrrrr@akhitsolutions.com)",
  //     },
  //     {
  //       id: 100,
  //       name: "richar (supuni+rrrrrr@akhitsolutions.com)",
  //     },
  //     {
  //       id: 101,
  //       name: "richar (supuni+rrrrrre@akhitsolutions.com)",
  //     },
  //     {
  //       id: 102,
  //       name: "Cee (supuni+cee@akhitsolutions.com)",
  //     },
  //     {
  //       id: 103,
  //       name: "CeeL (supuni+ce@akhitsolutions.com)",
  //     },
  //     {
  //       id: 104,
  //       name: "CeeL (supuni+ce1@akhitsolutions.com)",
  //     },
  //     {
  //       id: 105,
  //       name: "Barry (supuni+bl@akhitsolutions.com)",
  //     },
  //     {
  //       id: 106,
  //       name: "Justin (hyjokosyx@mailinator.com)",
  //     },
  //     {
  //       id: 107,
  //       name: "Violet (gefa@mailinator.com)",
  //     },
  //     {
  //       id: 108,
  //       name: "Josiah (moveqelely@mailinator.com)",
  //     },
  //     {
  //       id: 109,
  //       name: "Colton (sebe@mailinator.com)",
  //     },
  //     {
  //       id: 110,
  //       name: "Raphael (nidiropado@mailinator.com)",
  //     },
  //     {
  //       id: 111,
  //       name: "Lydia (wate@mailinator.com)",
  //     },
  //     {
  //       id: 112,
  //       name: "t (vapet@mailinator.com)",
  //     },
  //     {
  //       id: 113,
  //       name: "Ellen (supuni+ew@akhitsolutions.com)",
  //     },
  //     {
  //       id: 114,
  //       name: "Linda (supuni+lm@akhitsolutions.com)",
  //     },
  //     {
  //       id: 115,
  //       name: "Guinevere (fivuxegixy@mailinator.com)",
  //     },
  //     {
  //       id: 116,
  //       name: "cust fname sagi01 (sagi@akhitsolutions1.com)",
  //     },
  //     {
  //       id: 117,
  //       name: "Kamal (subangan+kh@akhitsolutions.com)",
  //     },
  //     {
  //       id: 118,
  //       name: "Shikhar (methshcr7+5@gmail.com)",
  //     },
  //     {
  //       id: 119,
  //       name: "Shikhar mda22 (admin+7@admin.com)",
  //     },
  //     {
  //       id: 120,
  //       name: "Ko (subangan+kk@akhitsolutions.com)",
  //     },
  //     {
  //       id: 121,
  //       name: "f1 (f@g.c)",
  //     },
  //     {
  //       id: 122,
  //       name: "veena (aevaev9@gmail.com)",
  //     },
  //     {
  //       id: 123,
  //       name: "veena (aevaev39@gmail.com)",
  //     },
  //     {
  //       id: 124,
  //       name: "aev (aev@gmail.com)",
  //     },
  //     {
  //       id: 125,
  //       name: "aev (aev1@gmail.com)",
  //     },
  //     {
  //       id: 126,
  //       name: "Benjamin (janav@mailinator.com)",
  //     },
  //     {
  //       id: 127,
  //       name: "Yoshio (lobyp@mailinator.com)",
  //     },
  //     {
  //       id: 128,
  //       name: "Kenneth (pegahyhaba@mailinator.com)",
  //     },
  //     {
  //       id: 129,
  //       name: "kuganesansdfsdf (qequtulimy@mailinator.com)",
  //     },
  //     {
  //       id: 130,
  //       name: "sri (iffcyjttfr9@xdaggmple.com)",
  //     },
  //     {
  //       id: 131,
  //       name: "sakthi (iffcyjttfr6@xdaggmple.com)",
  //     },
  //     {
  //       id: 132,
  //       name: "sakthi (iffcyttfr6@xdaggmple.com)",
  //     },
  //     {
  //       id: 133,
  //       name: "sakthi (iffcytfr6@xdaggmple.com)",
  //     },
  //     {
  //       id: 134,
  //       name: "yuvan (iffcytr6@xdaggmple.com)",
  //     },
  //     {
  //       id: 135,
  //       name: "yuvan (iffcytr6@xaggmple.com)",
  //     },
  //     {
  //       id: 136,
  //       name: "yuvan (idfddttfffcytr6@xaggmple.com)",
  //     },
  //     {
  //       id: 137,
  //       name: "kugan taest (idfddfrf6@xaggmple.com)",
  //     },
  //     {
  //       id: 138,
  //       name: "John kugan (john.sryeehi@example.com)",
  //     },
  //     {
  //       id: 139,
  //       name: "king king (m@s68dfdf45467tld.com)",
  //     },
  //     {
  //       id: 140,
  //       name: "king (m@s6845467tld.com)",
  //     },
  //     {
  //       id: 141,
  //       name: "king updat (m@s685467tld.com)",
  //     },
  //     {
  //       id: 142,
  //       name: "addresses new update (sumerawarsi@btinternet.com)",
  //     },
  //     {
  //       id: 143,
  //       name: "kugan company update (m@s6867tld.com)",
  //     },
  //     {
  //       id: 144,
  //       name: "kugan company (m@s67867tld.com)",
  //     },
  //     {
  //       id: 145,
  //       name: "kugan (m@s4tld.com)",
  //     },
  //     {
  //       id: 146,
  //       name: "new new (me@s4tld.com)",
  //     },
  //     {
  //       id: 147,
  //       name: "new new (me@s4tlsd.com)",
  //     },
  //     {
  //       id: 148,
  //       name: "new new (me@stl.com)",
  //     },
  //     {
  //       id: 149,
  //       name: "new new (me@tl.com)",
  //     },
  //     {
  //       id: 150,
  //       name: "new new (me@atl.com)",
  //     },
  //     {
  //       id: 151,
  //       name: "new new (me@atle.com)",
  //     },
  //     {
  //       id: 152,
  //       name: "met4rv (mef@xamptle.com)",
  //     },
  //     {
  //       id: 153,
  //       name: "met4rv (mehf@xamptle.com)",
  //     },
  //     {
  //       id: 154,
  //       name: "meterv (mehfv@xamptle.com)",
  //     },
  //     {
  //       id: 155,
  //       name: "meterhav (mehfv@examptle.com)",
  //     },
  //     {
  //       id: 156,
  //       name: "mehav (mehsafv@examptle.com)",
  //     },
  //     {
  //       id: 157,
  //       name: "mehav (mehav@examptle.com)",
  //     },
  //     {
  //       id: 158,
  //       name: "uwe update (england@examptle.com)",
  //     },
  //     {
  //       id: 159,
  //       name: "Jorden (rufuzir@mailinator.com)",
  //     },
  //     {
  //       id: 160,
  //       name: "Tashya (kyhivepo@mailinator.com)",
  //     },
  //     {
  //       id: 161,
  //       name: "Carissa (jigysaximo@mailinator.com)",
  //     },
  //     {
  //       id: 162,
  //       name: "Timon (kabexa@mailinator.com)",
  //     },
  //     {
  //       id: 163,
  //       name: "Cameron (qujihyd@mailinator.com)",
  //     },
  //     {
  //       id: 164,
  //       name: "Keegan (tynox@mailinator.com)",
  //     },
  //     {
  //       id: 165,
  //       name: "Nichole (pini@mailinator.com)",
  //     },
  //     {
  //       id: 166,
  //       name: "Ross (metupeluc@mailinator.com)",
  //     },
  //     {
  //       id: 167,
  //       name: "Kylee (limysejov@mailinator.com)",
  //     },
  //     {
  //       id: 168,
  //       name: "Amanda (sewimupa@mailinator.com)",
  //     },
  //     {
  //       id: 169,
  //       name: "Winifred (qeduryb@mailinator.com)",
  //     },
  //     {
  //       id: 170,
  //       name: "Winter (sazerox@mailinator.com)",
  //     },
  //     {
  //       id: 171,
  //       name: "Scarlett (rivutatuh@mailinator.com)",
  //     },
  //     {
  //       id: 172,
  //       name: "Taylor (caqog@mailinator.com)",
  //     },
  //     {
  //       id: 173,
  //       name: "Blythe (lopy@mailinator.com)",
  //     },
  //     {
  //       id: 174,
  //       name: "Nigel (hehexacyzy@mailinator.com)",
  //     },
  //     {
  //       id: 175,
  //       name: "Venus (divahewa@mailinator.com)",
  //     },
  //     {
  //       id: 176,
  //       name: "Kalia (jovawemu@mailinator.com)",
  //     },
  //     {
  //       id: 177,
  //       name: "Lenore (sizujeqapy@mailinator.com)",
  //     },
  //     {
  //       id: 178,
  //       name: "Hayley (pulovypy@mailinator.com)",
  //     },
  //     {
  //       id: 179,
  //       name: "Ryder (falowucugo@mailinator.com)",
  //     },
  //     {
  //       id: 180,
  //       name: "Quentin (nyjazid@mailinator.com)",
  //     },
  //     {
  //       id: 181,
  //       name: "Ashely (tojygo@mailinator.com)",
  //     },
  //     {
  //       id: 182,
  //       name: "Carson (bumuqa@mailinator.com)",
  //     },
  //     {
  //       id: 183,
  //       name: "Kamal (zory@mailinator.com)",
  //     },
  //     {
  //       id: 184,
  //       name: "Gray (wulu@mailinator.com)",
  //     },
  //     {
  //       id: 185,
  //       name: "Kimberley (zixyfy@mailinator.com)",
  //     },
  //     {
  //       id: 186,
  //       name: "Brynn (xyzy@mailinator.com)",
  //     },
  //     {
  //       id: 187,
  //       name: "Latifah (satapix@mailinator.com)",
  //     },
  //     {
  //       id: 188,
  //       name: "master (jo455@examptle.com)",
  //     },
  //     {
  //       id: 189,
  //       name: "master (jo45@examptle.com)",
  //     },
  //     {
  //       id: 190,
  //       name: "master (jo4e@examptle.com)",
  //     },
  //     {
  //       id: 191,
  //       name: "master (jo4e@example.com)",
  //     },
  //     {
  //       id: 192,
  //       name: "master (jo444e@example.com)",
  //     },
  //     {
  //       id: 193,
  //       name: "testwewekugan save (jo444wp@example.com)",
  //     },
  //     {
  //       id: 194,
  //       name: "test kugan save (jo444p@example.com)",
  //     },
  //     {
  //       id: 195,
  //       name: "test kugan save (jo444rp@example.com)",
  //     },
  //     {
  //       id: 196,
  //       name: "Theodore (saty@mailinator.com)",
  //     },
  //     {
  //       id: 197,
  //       name: "Maxwell (rycixu@mailinator.com)",
  //     },
  //     {
  //       id: 198,
  //       name: "Jeremy (fyzizasiny@mailinator.com)",
  //     },
  //     {
  //       id: 199,
  //       name: "Gage (qucujuge@mailinator.com)",
  //     },
  //     {
  //       id: 200,
  //       name: "Giselle (paca@mailinator.com)",
  //     },
  //     {
  //       id: 201,
  //       name: "Colby (hyxojis@mailinator.com)",
  //     },
  //     {
  //       id: 202,
  //       name: "Ignatius (jota@mailinator.com)",
  //     },
  //     {
  //       id: 203,
  //       name: "Keefe (dyso@mailinator.com)",
  //     },
  //     {
  //       id: 204,
  //       name: "Jelani (woxasu@mailinator.com)",
  //     },
  //     {
  //       id: 205,
  //       name: "Zahir (nytedon@mailinator.com)",
  //     },
  //     {
  //       id: 206,
  //       name: "Rina (taqad@mailinator.com)",
  //     },
  //     {
  //       id: 207,
  //       name: "Cedric (pydi@mailinator.com)",
  //     },
  //     {
  //       id: 208,
  //       name: "Phoebe (nesakyro@mailinator.com)",
  //     },
  //     {
  //       id: 209,
  //       name: "Justin (negiv@mailinator.com)",
  //     },
  //     {
  //       id: 210,
  //       name: "Rinah (vifawu@mailinator.com)",
  //     },
  //     {
  //       id: 211,
  //       name: "Rhonda (nupywuguzi@mailinator.com)",
  //     },
  //     {
  //       id: 212,
  //       name: "Beverly (wizeqyhu@mailinator.com)",
  //     },
  //     {
  //       id: 213,
  //       name: "Chester (gyhelege@mailinator.com)",
  //     },
  //     {
  //       id: 214,
  //       name: "Halla (visy@mailinator.com)",
  //     },
  //     {
  //       id: 215,
  //       name: "Jeanette (givilady@mailinator.com)",
  //     },
  //     {
  //       id: 216,
  //       name: "Carl (tizyhu@mailinator.com)",
  //     },
  //     {
  //       id: 217,
  //       name: "Philip (noselocog@mailinator.com)",
  //     },
  //     {
  //       id: 218,
  //       name: "Debra (ropir@mailinator.com)",
  //     },
  //     {
  //       id: 219,
  //       name: "Saji (neniratyx@mailinator.com)",
  //     },
  //     {
  //       id: 220,
  //       name: "Eugenia (xuvy@mailinator.com)",
  //     },
  //     {
  //       id: 221,
  //       name: "Hillary (lafocikobi@mailinator.com)",
  //     },
  //     {
  //       id: 222,
  //       name: "Erin (xoruxera@mailinator.com)",
  //     },
  //     {
  //       id: 223,
  //       name: "Peter (holu@mailinator.com)",
  //     },
  //     {
  //       id: 224,
  //       name: "Morgan (fozymyja@mailinator.com)",
  //     },
  //     {
  //       id: 225,
  //       name: "Leigh (gakedyz@mailinator.com)",
  //     },
  //     {
  //       id: 226,
  //       name: "John (nijoxe@mailinator.com)",
  //     },
  //     {
  //       id: 227,
  //       name: "webhook (kuganesan@akhitsolutions.com)",
  //     },
  //     {
  //       id: 228,
  //       name: "kuganesan update (jo442p@example.com)",
  //     },
  //     {
  //       id: 229,
  //       name: "kuganesan test (jo445p@example.com)",
  //     },
  //     {
  //       id: 230,
  //       name: "kuganesan1 (jo44oe@example.com)",
  //     },
  //     {
  //       id: 231,
  //       name: "rest1 (jo4doe@example.com)",
  //     },
  //     {
  //       id: 232,
  //       name: "  (sinthiya9166@gmail.com)",
  //     },
  //     {
  //       id: 233,
  //       name: " ()",
  //     },
  //     {
  //       id: 234,
  //       name: " ()",
  //     },
  //     {
  //       id: 235,
  //       name: "Jane (jane.doe@example.com)",
  //     },
  //     {
  //       id: 236,
  //       name: "Jane (jane.doe2@example.com)",
  //     },
  //     {
  //       id: 237,
  //       name: "Jane (jane.doe3@example.com)",
  //     },
  //     {
  //       id: 238,
  //       name: "Jane (jane.doe4@example.com)",
  //     },
  //     {
  //       id: 239,
  //       name: "Jane (jane.doe5@example.com)",
  //     },
  //     {
  //       id: 240,
  //       name: "Jane (jane.doe6@example.com)",
  //     },
  //     {
  //       id: 241,
  //       name: "Jane (jane.doe7@example.com)",
  //     },
  //     {
  //       id: 242,
  //       name: "Jane (jane.doe8@example.com)",
  //     },
  //     {
  //       id: 243,
  //       name: "Jane (jane.doe9@example.com)",
  //     },
  //     {
  //       id: 244,
  //       name: "Jane (jane.doe10@example.com)",
  //     },
  //     {
  //       id: 245,
  //       name: "Jane (jane.doe11@example.com)",
  //     },
  //     {
  //       id: 246,
  //       name: "Jane (jane.doe12@example.com)",
  //     },
  //     {
  //       id: 247,
  //       name: "Jane (jane.doe13@example.com)",
  //     },
  //     {
  //       id: 248,
  //       name: "Jane (jane.doe14@example.com)",
  //     },
  //     {
  //       id: 249,
  //       name: "Jane (jane.man14@example.com)",
  //     },
  //     {
  //       id: 250,
  //       name: "Jane (jane.man15@example.com)",
  //     },
  //     {
  //       id: 251,
  //       name: "Jane (jane.man16@example.com)",
  //     },
  //     {
  //       id: 252,
  //       name: "Jane (jane.man17@example.com)",
  //     },
  //     {
  //       id: 253,
  //       name: "Jane (jane.man18@example.com)",
  //     },
  //     {
  //       id: 254,
  //       name: "Jane (jane.man19@example.com)",
  //     },
  //     {
  //       id: 255,
  //       name: "Jane (jane.man20@example.com)",
  //     },
  //     {
  //       id: 256,
  //       name: "Jane (jane.ma920@example.com)",
  //     },
  //     {
  //       id: 257,
  //       name: "Jane (jane.ma930@example.com)",
  //     },
  //     {
  //       id: 258,
  //       name: "Jane (jane.ma730@example.com)",
  //     },
  //     {
  //       id: 259,
  //       name: "Jane (jane.ma770@example.com)",
  //     },
  //     {
  //       id: 260,
  //       name: "Saiteja (sai@citygoddess.co.uk)",
  //     },
  //     {
  //       id: 261,
  //       name: "Saiteja (sai@citygoddess.co.ukee)",
  //     },
  //     {
  //       id: 262,
  //       name: "Saiteja (sai@citygoddess.co.ukeeee)",
  //     },
  //     {
  //       id: 263,
  //       name: "Saiteja (sai@citygoddess.co.ukeeeer)",
  //     },
  //     {
  //       id: 264,
  //       name: "Saiteja (sai@citygoddess.co.ukeeeerd)",
  //     },
  //     {
  //       id: 265,
  //       name: "Saiteja (sai@citygoddess.co.ukeeeerds)",
  //     },
  //     {
  //       id: 266,
  //       name: "Saiteja (sai@citygoddess.co.ukeeeerdss)",
  //     },
  //     {
  //       id: 267,
  //       name: "Saiteja (sai@citygoddess.co.ukeeeerdsss)",
  //     },
  //     {
  //       id: 268,
  //       name: "Saiteja (sai@citygoddesss.co.uk)",
  //     },
  //     {
  //       id: 269,
  //       name: "Saiteja (sai@citygoddessss.co.uk)",
  //     },
  //     {
  //       id: 270,
  //       name: "mailinator first name (saitejamailinator@mailinator.com)",
  //     },
  //     {
  //       id: 271,
  //       name: "test 2 (test2sai@mailinator.com)",
  //     },
  //     {
  //       id: 272,
  //       name: "test 3 (saitejatest3@mailinator.com)",
  //     },
  //     {
  //       id: 273,
  //       name: "Ajay (ajay@goddiva.co.uk)",
  //     },
  //     {
  //       id: 274,
  //       name: " (thatsha@kugans.com)",
  //     },
  //     {
  //       id: 275,
  //       name: "Ajay (ajay+one@goddiva.co.uk)",
  //     },
  //     {
  //       id: 276,
  //       name: "Leo (vishnu@akhitsolutions.com)",
  //     },
  //   ],
  //   close_reasons: [
  //     {
  //       id: 1,
  //       reason: "Change of Mind",
  //     },
  //     {
  //       id: 2,
  //       reason: "Customer Cancel",
  //     },
  //     {
  //       id: 3,
  //       reason: "Test close reason",
  //     },
  //     {
  //       id: 4,
  //       reason: "expired",
  //     },
  //     {
  //       id: 5,
  //       reason: "Test",
  //     },
  //     {
  //       id: 6,
  //       reason: "Saji",
  //     },
  //     {
  //       id: 7,
  //       reason: "Test 1",
  //     },
  //   ],
  //   delivery_partner: [
  //     {
  //       id: 1,
  //       name: "Royal Mail",
  //     },
  //     {
  //       id: 2,
  //       name: "DPD",
  //     },
  //     {
  //       id: 3,
  //       name: "DHL",
  //     },
  //     {
  //       id: 4,
  //       name: "DPD Local",
  //     },
  //     {
  //       id: 5,
  //       name: "Evri",
  //     },
  //     {
  //       id: 6,
  //       name: "YODEL",
  //     },
  //     {
  //       id: 7,
  //       name: "UPS",
  //     },
  //     {
  //       id: 8,
  //       name: "PARCELFORCE",
  //     },
  //     {
  //       id: 9,
  //       name: "TNT",
  //     },
  //     {
  //       id: 10,
  //       name: "SEKO - Omni parcel",
  //     },
  //   ],
  //   product_categories: [
  //     {
  //       id: 33,
  //       name: "FRUITS",
  //     },
  //     {
  //       id: 32,
  //       name: "FRUIT UNIT",
  //     },
  //     {
  //       id: 30,
  //       name: "VEG UNIT",
  //     },
  //     {
  //       id: 18,
  //       name: "VEG",
  //     },
  //     {
  //       id: 23,
  //       name: "MEAT UNIT",
  //     },
  //     {
  //       id: 41,
  //       name: "MEAT WEIGHT",
  //     },
  //   ],
  //   order_status: [
  //     {
  //       id: 1,
  //       name: "Online Order",
  //       icon: "fa fa-shopping-bag",
  //       color: "rgb(179, 0, 59)",
  //     },
  //     {
  //       id: 2,
  //       name: "Picking",
  //       icon: "fa fa-pencil",
  //       color: "rgb(26, 102, 255)",
  //     },
  //     {
  //       id: 3,
  //       name: "Billing",
  //       icon: "fa fa-file-text-o",
  //       color: "rgb(255, 119, 51)",
  //     },
  //     {
  //       id: 4,
  //       name: "Packing",
  //       icon: "fa fa-archive",
  //       color: "rgb(0, 153, 255)",
  //     },
  //     {
  //       id: 5,
  //       name: "Ready To Ship",
  //       icon: "fa fa-truck",
  //       color: "rgb(230, 230, 0)",
  //     },
  //     {
  //       id: 6,
  //       name: "Shipped",
  //       icon: "fa fa-paper-plane",
  //       color: "rgb(255, 0, 255)",
  //     },
  //     {
  //       id: 7,
  //       name: "Closed",
  //       icon: "fa fa-times-circle",
  //       color: "rgb(255, 26, 26)",
  //     },
  //   ],
  //   return_reasons: [
  //     {
  //       id: 1,
  //       reason: "Damaged item",
  //     },
  //     {
  //       id: 2,
  //       reason: "Wrong item received",
  //     },
  //     {
  //       id: 3,
  //       reason: "Changed my mind",
  //     },
  //     {
  //       id: 4,
  //       reason: "Item not as described",
  //     },
  //     {
  //       id: 5,
  //       reason: "Better price available",
  //     },
  //     {
  //       id: 6,
  //       reason: "Test",
  //     },
  //     {
  //       id: 7,
  //       reason: "Test reason for return",
  //     },
  //     {
  //       id: 8,
  //       reason: "Wrong amount sent",
  //     },
  //     {
  //       id: 9,
  //       reason: "Te",
  //     },
  //   ],
  //   categories: [
  //     {
  //       id: 1,
  //       name: "NEWS & MAG",
  //     },
  //     {
  //       id: 2,
  //       name: "GENERAL",
  //     },
  //     {
  //       id: 3,
  //       name: "DRINKS",
  //     },
  //     {
  //       id: 4,
  //       name: "GROCERIES",
  //     },
  //     {
  //       id: 5,
  //       name: "ALCOHOL",
  //     },
  //     {
  //       id: 6,
  //       name: "CHILLED",
  //     },
  //     {
  //       id: 7,
  //       name: "CONFECTIONARY",
  //     },
  //     {
  //       id: 8,
  //       name: "HOUSEHOLD",
  //     },
  //     {
  //       id: 9,
  //       name: "BISCUITS",
  //     },
  //     {
  //       id: 11,
  //       name: "INSTANT LOTTERY",
  //     },
  //     {
  //       id: 12,
  //       name: "LOTTERY",
  //     },
  //     {
  //       id: 13,
  //       name: "LOTTO",
  //     },
  //     {
  //       id: 14,
  //       name: "TOYS",
  //     },
  //     {
  //       id: 15,
  //       name: "TOBACCO",
  //     },
  //     {
  //       id: 16,
  //       name: "FROZEN FOOD",
  //     },
  //     {
  //       id: 17,
  //       name: "PET FOOD",
  //     },
  //     {
  //       id: 18,
  //       name: "STATIONERY",
  //     },
  //     {
  //       id: 19,
  //       name: "CAKES",
  //     },
  //     {
  //       id: 20,
  //       name: "ICE CREAM",
  //     },
  //     {
  //       id: 21,
  //       name: "MEDICINE",
  //     },
  //     {
  //       id: 22,
  //       name: "SNACKS",
  //     },
  //     {
  //       id: 23,
  //       name: "PHONE CARD",
  //     },
  //     {
  //       id: 24,
  //       name: "STAMPS",
  //     },
  //     {
  //       id: 25,
  //       name: "PAYPOINT",
  //     },
  //     {
  //       id: 26,
  //       name: "BUS PASS",
  //     },
  //     {
  //       id: 28,
  //       name: "test-category",
  //     },
  //     {
  //       id: 30,
  //       name: "MEAT UNIT",
  //     },
  //     {
  //       id: 31,
  //       name: "Wine",
  //     },
  //     {
  //       id: 32,
  //       name: "Sanitary",
  //     },
  //     {
  //       id: 33,
  //       name: "FRUIT",
  //     },
  //     {
  //       id: 34,
  //       name: "FRUIT UNIT",
  //     },
  //     {
  //       id: 35,
  //       name: "003categry",
  //     },
  //     {
  //       id: 36,
  //       name: "005cat",
  //     },
  //     {
  //       id: 37,
  //       name: "Testwer",
  //     },
  //     {
  //       id: 38,
  //       name: "salespersontest",
  //     },
  //     {
  //       id: 39,
  //       name: "cat5",
  //     },
  //     {
  //       id: 40,
  //       name: "Test Cat sagi04",
  //     },
  //     {
  //       id: 41,
  //       name: "Test Cat sagi1",
  //     },
  //     {
  //       id: 42,
  //       name: "42",
  //     },
  //     {
  //       id: 43,
  //       name: "43",
  //     },
  //     {
  //       id: 44,
  //       name: "44",
  //     },
  //     {
  //       id: 45,
  //       name: "45",
  //     },
  //     {
  //       id: 46,
  //       name: "46",
  //     },
  //     {
  //       id: 47,
  //       name: "VEG UNIT",
  //     },
  //     {
  //       id: 48,
  //       name: "VEG",
  //     },
  //     {
  //       id: 49,
  //       name: "48",
  //     },
  //     {
  //       id: 50,
  //       name: "MEAT WEIGHT",
  //     },
  //     {
  //       id: 51,
  //       name: "Saji",
  //     },
  //     {
  //       id: 52,
  //       name: "wwww",
  //     },
  //     {
  //       id: 53,
  //       name: "abc",
  //     },
  //     {
  //       id: 54,
  //       name: "test",
  //     },
  //     {
  //       id: 55,
  //       name: "Coffee, Tea & Malts",
  //     },
  //     {
  //       id: 56,
  //       name: "Breakfast & Bakery",
  //     },
  //     {
  //       id: 57,
  //       name: "Decorations",
  //     },
  //     {
  //       id: 58,
  //       name: "Beauty Picks",
  //     },
  //     {
  //       id: 59,
  //       name: "fruits",
  //     },
  //     {
  //       id: 60,
  //       name: "000000000000000000000001",
  //     },
  //     {
  //       id: 61,
  //       name: "cat sagi",
  //     },
  //     {
  //       id: 62,
  //       name: "test cat sagi02",
  //     },
  //     {
  //       id: 63,
  //       name: "test cat sagi no vat",
  //     },
  //     {
  //       id: 64,
  //       name: "Test new Cat Sagi",
  //     },
  //     {
  //       id: 65,
  //       name: "Desserts",
  //     },
  //     {
  //       id: 66,
  //       name: "Baby Care",
  //     },
  //     {
  //       id: 67,
  //       name: "Flowers",
  //     },
  //     {
  //       id: 68,
  //       name: "Home & Living",
  //     },
  //     {
  //       id: 69,
  //       name: "Makeup",
  //     },
  //     {
  //       id: 70,
  //       name: "Test category",
  //     },
  //     {
  //       id: 71,
  //       name: "Travel Accessories",
  //     },
  //   ],
  //   exchange_delete_reason: [
  //     {
  //       id: 1,
  //       name: "Original product is available now",
  //     },
  //     {
  //       id: 2,
  //       name: "User request",
  //     },
  //   ],
  //   discount_type: [
  //     {
  //       id: 1,
  //       name: "Buy 1 get 1",
  //     },
  //     {
  //       id: 2,
  //       name: "Buy X get Y",
  //     },
  //     {
  //       id: 3,
  //       name: "Amount off product",
  //     },
  //     {
  //       id: 4,
  //       name: "Amount off order",
  //     },
  //     {
  //       id: 5,
  //       name: "Free shipping",
  //     },
  //   ],
  // };
  return { response };
};

export const getDiscountSettingsApi = async () => {
  //   const response = await API.get(`discount/settings`);
  const response = {
    user: [
      {
        id: 1,
        name: "methan",
        email: "methshcr7@gmail.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-03-23T19:13:58.000000Z",
        updated_at: "2022-06-28T11:42:21.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 2,
        name: "Yathu Kanagaratnam",
        email: "yathu@citygoddess.co.uk",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-06-23T12:55:43.000000Z",
        updated_at: "2022-06-23T12:55:43.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 3,
        name: "Sinthiya",
        email: "sinthiya@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-06-23T13:46:38.000000Z",
        updated_at: "2022-06-23T13:46:38.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 4,
        name: "Ananth Angel",
        email: "ananth@kugans.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-06-24T16:37:44.000000Z",
        updated_at: "2022-06-24T16:37:44.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 5,
        name: "Balu",
        email: "balu@kugans.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-06-24T16:37:53.000000Z",
        updated_at: "2022-06-24T16:37:53.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 6,
        name: "Deep",
        email: "deep@kugans.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-06-24T16:38:19.000000Z",
        updated_at: "2022-06-24T16:38:19.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 7,
        name: "Krish",
        email: "krish@kugans.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-06-24T16:38:28.000000Z",
        updated_at: "2022-06-24T16:38:28.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 8,
        name: "Thatsha",
        email: "thatsha@kugans.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-06-25T13:02:04.000000Z",
        updated_at: "2022-06-25T13:02:04.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 9,
        name: "heroshika",
        email: "heroshi@kugans.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-06-26T07:43:14.000000Z",
        updated_at: "2022-06-26T07:43:14.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 10,
        name: "Raghu",
        email: "raghu@kugans.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-06-26T07:43:32.000000Z",
        updated_at: "2022-06-26T07:43:32.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 12,
        name: "veena",
        email: "veena@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-07-25T10:49:21.000000Z",
        updated_at: "2022-07-25T10:49:21.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 14,
        name: "Zara",
        email: "zara@test.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-07-28T08:28:45.000000Z",
        updated_at: "2022-07-28T08:28:45.000000Z",
        role: {
          id: 2,
          name: "Admin",
        },
      },
      {
        id: 16,
        name: "Jeni",
        email: "Jeni@test.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-07-29T05:46:38.000000Z",
        updated_at: "2022-07-29T05:46:38.000000Z",
        role: {
          id: 2,
          name: "Admin",
        },
      },
      {
        id: 24,
        name: "Ranul Randombage",
        email: "ranul@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-09-01T13:22:09.000000Z",
        updated_at: "2022-09-01T13:22:09.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 27,
        name: "m",
        email: "It13116248@my.sliit.lk",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-09-01T14:07:07.000000Z",
        updated_at: "2022-09-01T14:07:07.000000Z",
        role: {
          id: 2,
          name: "Admin",
        },
      },
      {
        id: 28,
        name: "Nayana Darshana",
        email: "nayana@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-09-01T14:09:20.000000Z",
        updated_at: "2022-12-02T13:07:26.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 30,
        name: "Subangan",
        email: "subangan@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-09-02T13:38:29.000000Z",
        updated_at: "2022-12-19T12:33:28.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 31,
        name: "salesperson1",
        email: "salesperson1@gmail.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-09-20T13:50:35.000000Z",
        updated_at: "2022-12-12T14:58:34.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 32,
        name: "t2",
        email: "t2@gmail.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-10-11T16:41:03.000000Z",
        updated_at: "2022-10-11T16:41:03.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 34,
        name: "Subangan CITY GODDESS",
        email: "subangan@citygoddess.co.uk",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-10-14T16:55:10.000000Z",
        updated_at: "2024-12-20T07:13:54.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 36,
        name: "Vinojan",
        email: "vinojan@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-12-08T09:27:46.000000Z",
        updated_at: "2022-12-08T09:27:46.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 37,
        name: "s",
        email: "s@gmail.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-12-12T15:29:15.000000Z",
        updated_at: "2022-12-12T15:29:15.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 38,
        name: "vinojan",
        email: "v2@gmail.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2022-12-22T17:25:57.000000Z",
        updated_at: "2022-12-22T17:25:57.000000Z",
        role: {
          id: 2,
          name: "Admin",
        },
      },
      {
        id: 40,
        name: "test1",
        email: "test@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2023-01-03T11:04:39.000000Z",
        updated_at: "2023-01-03T11:04:39.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 54,
        name: "veena9",
        email: "veena94318@gmail.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2023-01-31T09:43:39.000000Z",
        updated_at: "2024-06-06T15:11:17.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 55,
        name: "petote6769",
        email: "petote6769@crtsec.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2023-01-31T19:21:51.000000Z",
        updated_at: "2023-01-31T19:21:51.000000Z",
        role: {
          id: "",
          name: "",
        },
      },
      {
        id: 56,
        name: "noyixa6501",
        email: "noyixa6501@crtsec.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2023-01-31T19:41:38.000000Z",
        updated_at: "2023-01-31T19:41:38.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 58,
        name: "gemam91377",
        email: "gemam91377@ezgiant.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2023-01-31T19:47:07.000000Z",
        updated_at: "2023-01-31T19:47:07.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 59,
        name: "lSOMa2Sd",
        email: "helap87603@wireps.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2023-02-24T09:31:29.000000Z",
        updated_at: "2023-02-24T09:36:14.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 60,
        name: "Shanuka Croos",
        email: "shanuka@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2024-06-24T06:15:18.000000Z",
        updated_at: "2024-06-24T06:18:12.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 61,
        name: "Supuni",
        email: "supuni@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2024-07-02T07:48:39.000000Z",
        updated_at: "2024-07-02T07:48:39.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 62,
        name: "Bala",
        email: "shop@kugans.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2024-07-09T10:40:36.000000Z",
        updated_at: "2024-07-09T10:40:36.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 63,
        name: "Divakshana",
        email: "divakshana@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2024-07-09T10:47:39.000000Z",
        updated_at: "2024-07-09T10:47:39.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 64,
        name: "Sales Person",
        email: "supuni+sp@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2024-07-19T11:20:41.000000Z",
        updated_at: "2024-07-19T11:20:41.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 65,
        name: "Amaya",
        email: "amaya@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2024-08-12T06:47:30.000000Z",
        updated_at: "2024-12-05T09:05:36.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 66,
        name: "Saji",
        email: "gayle@gmail.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2024-08-14T06:18:31.000000Z",
        updated_at: "2024-08-14T06:18:31.000000Z",
        role: {
          id: 2,
          name: "Admin",
        },
      },
      {
        id: 68,
        name: "sagi",
        email: "sagi@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2024-09-11T06:40:19.000000Z",
        updated_at: "2024-09-11T06:40:19.000000Z",
        role: {
          id: 2,
          name: "Admin",
        },
      },
      {
        id: 69,
        name: "Vathanie",
        email: "mariavathanie@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2024-10-20T11:47:55.000000Z",
        updated_at: "2024-10-20T11:47:55.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 70,
        name: "Sajinthan",
        email: "Sajinthan@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2024-10-30T06:56:05.000000Z",
        updated_at: "2024-10-30T06:58:40.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 72,
        name: "Subangan Sales",
        email: "subangan+sales@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2025-03-19T09:33:35.000000Z",
        updated_at: "2025-03-19T09:33:35.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
      {
        id: 73,
        name: "Ajay Kumar",
        email: "ajay@goddiva.co.uk",
        email_verified_at: null,
        image_path: null,
        created_at: "2025-03-22T17:39:45.000000Z",
        updated_at: "2025-03-22T17:39:45.000000Z",
        role: {
          id: 1,
          name: "Super Admin",
        },
      },
      {
        id: 75,
        name: "Sajinthan Sales",
        email: "Sajinthan+sales@akhitsolutions.com",
        email_verified_at: null,
        image_path: null,
        created_at: "2025-03-31T07:00:09.000000Z",
        updated_at: "2025-03-31T07:00:09.000000Z",
        role: {
          id: 3,
          name: "Sales Person",
        },
      },
    ],
    type: [
      {
        id: 1,
        name: "Buy 1 get 1",
      },
      {
        id: 2,
        name: "Buy X get Y",
      },
      {
        id: 3,
        name: "Amount off product",
      },
      {
        id: 4,
        name: "Amount off order",
      },
      {
        id: 5,
        name: "Free shipping",
      },
    ],
    status: [
      {
        id: 1,
        name: "Active",
      },
      {
        id: 2,
        name: "Expired",
      },
      {
        id: 3,
        name: "Scheduled",
      },
    ],
    combined_discounts: {
      product_discount: {
        count: 0,
        data: [],
      },
      order_discount: {
        count: 0,
        data: [],
      },
      shipping_discount: {
        count: 0,
        data: [],
      },
    },
    $countries: [
      {
        id: 241,
        name: "United Kingdom",
        code: "GB",
      },
    ],
  };
  return { response };
};

export const searchDiscountProductApi = async data => {
	const response = await API.get('discount/product-search', { params: data });
	return { response };
};
